import Swiper from 'swiper/bundle';

import isIEbrowser from '../../../resources/scripts/helpers/is-ie';

class BrixImageCarousel {
  static init(...parameters) {
    return new BrixImageCarousel(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    const IE = isIEbrowser();
    this.swiperContainer = selector.querySelector('.swiper-container');
    this.swiperPagination = selector.querySelector('.swiper-pagination');
    this.swiperNext = selector.querySelector('.swiper-navigation-slide-next');
    this.swiperPrev = selector.querySelector('.swiper-navigation-slide-prev');
    this.swiperActiveSlide = selector.querySelector('.active-slide');
    this.swiperTotalSlides = selector.querySelector('.total-slides');

    const brixCarousel = this;
    const enableAutoplay = this.swiperContainer.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(this.swiperContainer.dataset.autoplayDelay, 10) * 1000;

    this.mySwiper = new Swiper(this.swiperContainer, {
      pagination: {
        el: this.swiperPagination,
        type: 'bullets',
        clickable: true,
        bulletElement: 'div',
      },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
      autoplay: enableAutoplay ? { delay: autoplayDelay } : false,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      on: {
        init() {
          brixCarousel.swiperActiveSlide.innerText = this.realIndex + 1;
        },
        slideChange() {
          brixCarousel.setCaption();
          brixCarousel.swiperActiveSlide.innerText = this.realIndex + 1;
        },
      },
    });

    if (this.mySwiper && IE) {
      window.objectFitPolyfill();
    }

    this.setCaption();

    window.addEventListener('resize', () => {
      // Render on resize to update swiper
      this.mySwiper.update();
    });
  }

  setCaption() {
    if (!this.mySwiper) return;

    const captionElement = this.selector.querySelector('.slide-caption');
    if (!captionElement) return;

    const { activeIndex } = this.mySwiper;
    const activeSlide = this.mySwiper.slides[activeIndex];
    captionElement.innerText = activeSlide.dataset.caption;
    if (activeSlide.dataset.caption.length === 0) {
      captionElement.classList.add('-empty');
    } else {
      captionElement.classList.remove('-empty');
    }
  }
}


// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-image-carousel', BrixImageCarousel.init);
}
